
import Vue from 'vue'
import App from './index.vue'
import router from '../../router'
import Axios from 'axios'
import store from '../../store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import captcha from '../../plugins/captcha'

Vue.use(ElementUI);
Vue.use(captcha);
Vue.prototype.$bus = new Vue();

Axios.defaults.withCredentials=true;
Axios.interceptors.request.use(function (config) {
  // store.state.isloading = true;
  return config;
})
Axios.interceptors.response.use(function (config) {
  // store.state.isloading = false
  return config;
})
Vue.prototype.$ajax = Axios;
Vue.config.productionTip = false

// 注入url配置
Vue.prototype.$url = process.env.BASE_URL
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js